// eslint-disable-next-line angular/factory-name
angular.
module("digiexam.gradingMatrix").
factory("GradingMatrix", function gradingMatrixFactory(
	$http,

	dxSession,
	GradingMatrixGrade,
	GradingMatrixAbility,
	GradingMatrixCriteria,
	PermissionShareEnum,
	DX_URLS
) {
	"use strict";

	function findHighestId(collection) {
		return collection.reduce(function reduce(currentHigh, item) {
			return Math.max(currentHigh, item.id);
		}, 0);
	}

	function GradingMatrix(argData) {
		var defaults = {
			id: 0,
			userId: dxSession.getUser().id,
			title: "",
			description: "",
			grades: [
				{id: 1, title: "A"},
				{id: 2, title: "B"},
				{id: 3, title: "C"},
				{id: 4, title: "D"},
				{id: 5, title: "E"},
				{id: 6, title: "F"}],
			abilities: [],
			criteria: [],
			isArchived: false,
		};

		var data = angular.extend(defaults, argData);

		if (data.grades) {
			data.grades = data.grades.map(function mapFn(grade) {
				return new GradingMatrixGrade(grade);
			});
		}
		if (data.abilities) {
			data.abilities = data.abilities.map(function mapFn(ability) {
				return new GradingMatrixAbility(ability);
			});
		}
		if (data.criteria) {
			data.criteria = data.criteria.map(function mapFn(criteria) {
				return new GradingMatrixCriteria(criteria);
			});
		}

		angular.extend(this, data);
	}

	GradingMatrix.prototype.isValid = isValid;
	GradingMatrix.prototype.addGrade = addGrade;
	GradingMatrix.prototype.addAbility = addAbility;
	GradingMatrix.prototype.getCriterion = getCriterion;
	GradingMatrix.prototype.nextSiblingFor = nextSiblingFor;
	GradingMatrix.prototype.prevSiblingFor = prevSiblingFor;
	GradingMatrix.prototype.remove = remove;
	GradingMatrix.prototype.share = share;
	GradingMatrix.prototype.isFirstAbility = isFirstAbility;
	GradingMatrix.prototype.isLastAbility = isLastAbility;
	GradingMatrix.prototype.moveAbility = moveAbility;
	GradingMatrix.prototype.moveAbilityUp = moveAbilityUp;
	GradingMatrix.prototype.moveAbilityDown = moveAbilityDown;

	function isValid(argOutErrors) {
		// The keys are required so we can use them in ng-repeat and avoid the "duplicates" error.
		// https://docs.angularjs.org/error/ngRepeat/dupes
		var outErrors = argOutErrors || [];

		if (!this.title) {
			outErrors.push({
				key: "no-title",
				message: "YouNeedToSetATitle",
			});
		}

		if (this.grades.length === 0) {
			outErrors.push({
				key: "no-grades",
				message: "YouNeedToAddGrades",
			});
		} else {
			for (var i = 0; i < this.grades.length; i++) {
				var grade = this.grades[i];

				if (!grade.title) {
					outErrors.push({
						key: "no-grade-title-" + grade.id,
						message: "GradeNameIsRequired",
					});
				}
			}
		}

		if (this.abilities.length === 0) {
			outErrors.push({
				key: "no-abilities",
				message: "YouNeedToAddAbilities",
			});
		} else {
			for (var j = 0; j < this.abilities.length; j++) {
				var ability = this.abilities[j];

				if (!ability.title) {
					outErrors.push({
						key: "no-ability-title-" + ability.id,
						message: "AbilityNameIsRequired",
					});
				}
			}
		}

		return outErrors.length === 0;
	}

	function addGrade() {
		var grade = new GradingMatrixGrade({
			id: findHighestId(this.grades) + 1,
			title: "",
		});

		this.grades.push(grade);

		for (var i = 0; i < this.abilities.length; i++) {
			this.criteria.push(new GradingMatrixCriteria({
				gradeId: grade.id,
				abilityId: this.abilities[i].id,
				description: "",
			}));
		}

		return grade;
	}

	function addAbility() {
		var ability = new GradingMatrixAbility({
			id: findHighestId(this.abilities) + 1,
			title: "",
		});

		this.abilities.push(ability);

		for (var i = 0; i < this.grades.length; i++) {
			this.criteria.push(new GradingMatrixCriteria({
				gradeId: this.grades[i].id,
				abilityId: ability.id,
				description: "",
			}));
		}

		return ability;
	}

	// TODO(kenneth): Should be refactored to take the IDs directly instead
	// of objects, so it's easier to use when you only have the IDs.
	function getCriterion(grade, ability) {
		for (var i = 0; i < this.criteria.length; i++) {
			var criterion = this.criteria[i];
			if (criterion.gradeId === grade.id && criterion.abilityId === ability.id) {
				return criterion;
			}
		}
		return null;
	}

	function nextSiblingFor(element) {
		// NOTE(robin): Don't access the last element since it does not have a next sibling
		for (var i = 0; i < this.grades.length - 1; i++) {
			if (this.grades[i] === element) {
				return this.grades[i + 1];
			}
		}

		for (var j = 0; j < this.abilities.length - 1; j++) {
			if (this.abilities[j] === element) {
				return this.abilities[j + 1];
			}
		}

		return null;
	}

	function prevSiblingFor(element) {
		// NOTE(robin): Don't access the first element since it does not have a prev sibling
		for (var i = 1; i < this.grades.length; i++) {
			if (this.grades[i] === element) {
				return this.grades[i - 1];
			}
		}

		for (var j = 1; j < this.abilities.length; j++) {
			if (this.abilities[j] === element) {
				return this.abilities[j - 1];
			}
		}

		return null;
	}

	function remove(element) {
		for (var i = 0; i < this.grades.length; i++) {
			var grade = this.grades[i];
			if (element === grade) {
				for (var j = this.criteria.length - 1; j >= 0; j--) {
					if (this.criteria[j].gradeId === grade.id) {
						this.criteria.splice(j, 1);
					}
				}
				this.grades.splice(i, 1);
				return;
			}
		}

		for (var m = 0; m < this.abilities.length; m++) {
			var ability = this.abilities[m];
			if (element === ability) {
				for (var n = this.criteria.length - 1; n >= 0; n--) {
					if (this.criteria[n].abilityId === ability.id) {
						this.criteria.splice(n, 1);
					}
				}
				this.abilities.splice(m, 1);
				return;
			}
		}
	}

	function share(email) {
		var promise = $http.post(DX_URLS.get("share"), {objectId: this.id, email: email, permission: PermissionShareEnum.LIBRARY_GRADINGMATRIX});
		return promise.then(function success(response) {
			return response.data;
		});
	}

	function isFirstAbility(index) {
		return index === 0;
	}

	function isLastAbility(index) {
		return index === this.abilities.length - 1;
	}

	function moveAbility(currentIndex, newIndex) {
		if (!(this.abilities[currentIndex] && this.abilities[newIndex])) {
			return;
		}
		var movedAbility = this.abilities[currentIndex];
		this.abilities[currentIndex] = this.abilities[newIndex];
		this.abilities[newIndex] = movedAbility;
	}

	function moveAbilityUp(currentIndex) {
		this.moveAbility(currentIndex, currentIndex - 1);
	}

	function moveAbilityDown(currentIndex) {
		this.moveAbility(currentIndex, currentIndex + 1);
	}

	return GradingMatrix;
});
